import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pdf-viewer" }
const _hoisted_2 = { class: "pdf-viewer--actions" }
const _hoisted_3 = ["data"]
const _hoisted_4 = {
  key: 1,
  class: "order-operational-data__fulfillments"
}
const _hoisted_5 = { class: "fulfillment-item" }
const _hoisted_6 = { class: "fulfillment-item__shipment" }
const _hoisted_7 = {
  class: "shipment__carrier",
  style: { color: 'var(--directr__dark-slate-blue)' }
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "meta shipment__id" }
const _hoisted_10 = {
  key: 1,
  class: "fulfillment-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.currentDialog)
      ? (_openBlock(), _createBlock(_component_q_dialog, {
          key: 0,
          modelValue: _ctx.state.dialog[_ctx.state.currentDialog],
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dialog[_ctx.state.currentDialog]) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_btn, {
                  unelevated: "",
                  rounded: "",
                  outline: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reprintFulfillment()))
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Print Shipment Labels")
                  ])),
                  _: 1
                }),
                _createVNode(_component_q_btn, {
                  unelevated: "",
                  rounded: "",
                  outline: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reprintFulfillment(true)))
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Print Packing Slip")
                  ])),
                  _: 1
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.document[_ctx.state.currentDialog], (doc, i) => {
                return (_openBlock(), _createElementBlock("object", {
                  type: "application/pdf",
                  data: doc?.startsWith('data:application') ? doc : `data:application/pdf;base64,${doc}`,
                  style: {"width":"100%","height":"100%"}
                }, null, 8, _hoisted_3))
              }), 256))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.data?.fulfillment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "fulfillments", {}, () => [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.data?.fulfillment)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.data?.fulfillment.shipments, (shipment, i) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("b", _hoisted_7, "Carrier " + _toDisplayString(shipment.carrier) + "  ", 1),
                      (_ctx.trackingUrl[shipment.id])
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "shipment__tracking-url",
                            href: _ctx.trackingUrl[shipment.id],
                            target: "_blank"
                          }, "Track shipment", 8, _hoisted_8))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, "Shipment code | " + _toDisplayString(shipment.id || shipment.shipment), 1)
                    ]))
                  }), 256))
                : _createCommentVNode("", true),
              (_ctx.data?.fulfillment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("button", {
                      class: "minimal",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getPackingSlip(_ctx.data?.fulfillment.id)))
                    }, "View Packing Slip"),
                    _createElementVNode("button", {
                      class: "minimal",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getShipmentLabels(_ctx.data?.fulfillment.id)))
                    }, "View Shipment Labels")
                  ]))
                : _createCommentVNode("", true)
            ])
          ], true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}